import {err} from 'framework';
import type {Result, UseCase, ValidationError} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {WorkoutTemplate} from '../../domain/workout-template';
import type {
  UpdateWorkoutTemplateInput,
  WorkoutRepository,
} from '../ports/workout.repository';
import type {UpdateWorkoutTemplateDataValidator} from '../validators/update-workout-template-data.validator';

export class UpdateWorkoutTemplate
  implements UseCase<[UpdateWorkoutTemplateInput], WorkoutTemplate>
{
  constructor(
    private readonly repository: WorkoutRepository,
    private readonly validator: UpdateWorkoutTemplateDataValidator,
  ) {}

  execute(
    input: UpdateWorkoutTemplateInput,
  ): Promise<Result<WorkoutTemplate, WorkoutError | ValidationError>> {
    const validated = this.validator.validate(input);
    if (!validated.ok) {
      return Promise.resolve(err(validated.error));
    }
    return this.repository.updateTemplate(validated.data);
  }
}
